import { NextPage } from 'next'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import FoldText from '~/components/FoldText'
import NotificationBar from '~/components/NotificationBar'
import Space from '~/components/Space'
import {
  IncomeExpensesArea,
  LonBuyBackArea,
  BuybackHistoryList,
} from './components'
import { useLocalStorage } from '~/hooks/useLocalStorage'
import {
  StyledBuybackContentWrapper,
  StyledBuybackWrap,
  StyledLonBuybackHeadContainer,
  StyledMainBuybackContainer,
} from './styled'
import { StyledTitleIcon } from '~/components/TradeMining/styled'
import IconBuyback from '~/assets/images/buyback-light.svg'

const Buyback: NextPage = () => {
  const { t } = useTranslation()
  const notificationLink =
  'https://snapshot.org/#/s:tokenlon.eth/proposal/0xf464889233c044b056cc55f1e634664b815f3f7ea1c54212ab820f52eee0e0f1'

  const [visitedNotification, setVisitedNotification] = useLocalStorage(
    'buyback-notification-20260122-visited',
    false,
  )

  const handleNotificationLinkClick = () => {
    window.open(notificationLink, '_blank', 'noopener,noreferrer')
  }

  return (
    <StyledBuybackWrap>
      <Head>
        <title>{t('meta_lon_buyback_title')}</title>
        <meta name="description" content={t('meta_lon_buyback_description')} />
        <meta name="keywords" content={t('meta_lon_keywords')} />
      </Head>
      <Header />
      <StyledBuybackContentWrapper>
        <StyledMainBuybackContainer>
          <StyledLonBuybackHeadContainer>
            {!visitedNotification && (
              <>
                <NotificationBar
                  text={t('buyback_notification')}
                  handleClose={() => setVisitedNotification(true)}
                  handleLinkClick={handleNotificationLinkClick}
                />
                <Space height={40} />
              </>
            )}
            <div className="header">
              <StyledTitleIcon src={IconBuyback} />
              <h1 className="title">{t('buyback_page_title')}</h1>
            </div>
            <p className="description">
              <FoldText texts={[t('buyback_page_desc')]} />
            </p>
          </StyledLonBuybackHeadContainer>
          <IncomeExpensesArea />
          <LonBuyBackArea />
          <BuybackHistoryList />
        </StyledMainBuybackContainer>
      </StyledBuybackContentWrapper>
      <Footer />
    </StyledBuybackWrap>
  )
}

export default Buyback
